'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var rngBrowser = {exports: {}};

exports.rngBrowser = rngBrowser;
